import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { SupportService } from 'src/app/support.service';
import { Bank } from 'src/typings';
import { BankService } from '../bank.service';

@Component({
  selector: 'app-bank-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss']
})
export class SelectorComponent implements OnInit {
  constructor(private bankService: BankService, public supportService: SupportService) {}

  banks: Observable<Bank[]> = this.bankService.getList();

  filteredOptions: Observable<Observable<Bank[]>> = new Observable();

  value: any;

  @Input() control: UntypedFormControl = new UntypedFormControl('');

  @Input() label = 'Банк';

  public displayProperty(bank: Bank) {
    if (bank) return bank.description;
    return '';
  }

  ngOnInit(): void {
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }

  private _filter(value: string | Bank): Observable<Bank[]> {
    const lowerValue =
      typeof value === 'string' ? value.toLowerCase() : value?.description.toLowerCase();

    return this.banks.pipe(
      map((banks) =>
        banks.filter((bank) => {
          if (!lowerValue) return true;
          return bank.description.toLowerCase().includes(lowerValue);
        })
      )
    );
  }

  // handleSelect(event: MatAutocompleteSelectedEvent) {
  //   if(typeof event.option.value === "string") {
  //     this.brandService.create(event.option.value).subscribe(data => {
  //       this.notificationService.notice(`Производитель ${data.description} создан!`)
  //       this.control.setValue(data)
  //     })
  //     }
  //   }
}
